import { UTCDate } from '@date-fns/utc'
import { createGlobalState, useNow } from '@vueuse/core'
import { differenceInSeconds, format } from 'date-fns'

export const useIslandTime = createGlobalState(() => {
  const now = useNow({ interval: 1000 })

  const timeAgo = (dateStr: string | Date) => {
    const date = new UTCDate(dateStr)
    const diff = differenceInSeconds(now.value, date)

    return formatDuration(diff)
  }

  const formatDuration = (seconds: number) => {
    if (seconds < 60) return `${seconds}s`
    if (seconds < 3600) return `${Math.floor(seconds / 60)}min`
    if (seconds < 86400) return `${Math.floor(seconds / 3600)}hr`
    return `${Math.floor(seconds / 86400)}d`
  }

  const getIslandTime = (date: Date) => format(new UTCDate(date), 'h:mm a, EEE, MMMM d, yyyy')

  return {
    timeAgo,
    formatDuration,
    getIslandTime,
  }
})
